exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "table.chemicals-table {\n  border: 1px solid #e0e0e0; }\n  table.chemicals-table thead tr th:first-child {\n    padding-left: 20px !important; }\n  table.chemicals-table tbody tr td:first-child {\n    padding-left: 20px !important; }\n", ""]);

